import { FC } from 'react'

import { ExtendedRegistry } from 'src/types/registry'

import styles from './GiftTrackerHeader.styles.scss'

import SearchRow from './SearchRow'
import GiftsPurchased from './GiftsPurchased'
import DownloadCSV from './DownloadCSV'

const Title: FC = () => (
  <div className={styles.GiftTrackerHeader__Title}>Gift tracker</div>
)

const DotSeparator: FC = () => (
  <div className={styles.GiftTrackerHeader__DotSeparator}>·</div>
)

const GiftsPurchasedAndDownloadRow: FC<{ registry: ExtendedRegistry }> = ({
  registry: { giftsPurchasedCount, regItemsCount },
}) => (
  <div className={styles.GiftTrackerHeader__GiftsPurchasedAndDownloadRow}>
    <GiftsPurchased
      giftsPurchasedCount={giftsPurchasedCount}
      regItemsCount={regItemsCount}
    />
    <DotSeparator />
    <DownloadCSV />
  </div>
)

const TitleRow: FC<{ registry: ExtendedRegistry }> = ({ registry }) => (
  <div className={styles.GiftTrackerHeader__TitleRow}>
    <Title />
    <GiftsPurchasedAndDownloadRow registry={registry} />
  </div>
)

const GiftTrackerHeader: FC<{ registry: ExtendedRegistry }> = ({
  registry,
}) => (
  <div className={styles.GiftTrackerHeader}>
    <TitleRow registry={registry} />
    <SearchRow />
  </div>
)

export default GiftTrackerHeader
